import { mdmRegistryObj } from "../../features/mdm/mdmRegistry";
import store from "../store";

export function setCurrentEntity(currentEntity:mdmRegistryObj){
    store.dispatch({
        type:"setCurrentEntity",
        payload: currentEntity
    })
}